module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAASRJREFUOE+dk4GxATEQhqUCOuAqQAV0gAoeFaADOqACStCB08FdBU8JOjjff5KbWHcGN/PPbZLdb7ObxLXMVxRFj6klGqOBX874p2jvnLvGIS4eELzzwZYbj3dA1mGiAhCsLP13kdFaBmSocQn4MLNlq5yV8zX/12TeMndENzRFKq9t/BIB6ureQt94eAc7w1ZTzwawF6Cu9kTdZk3ZlXXoITqB7lMvcCrs9nEOvRG8hwYemGKPYn/t4AWAw4yAU+zY1KumEqpjChAAAk7MbvOmJsrvyC4WMgie8zvYUhmXTVSN9hgvikNqmvqwQpr7M5Ck6SKFuy94x0Nk6z6E73GRohq/uco5weVD++UxlZlD4ieAb5i2KocxCo8rx06RXqL6Un13rUyE9pk89iQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer_ico.png
// module id = abQ6
// module chunks = 14